import { useMemo } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Box, Checkbox, Column, Typography } from 'seagull';
import { getStepName } from "../../../../ClientOnboarding.utils";
import { contentTransition, contentVariants } from "../animations";
import { StepContent } from "../StepContent";
import { GetStepsContainerTID } from "./StepsContainer";
import styles from "./StepsContainerMobile.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const StepsContainerMobile = _ref => {
  let {
    testId,
    currentStep,
    direction,
    relationship,
    statement,
    isStatementAccepted,
    onStatementChange
  } = _ref;
  const {
    StepsContainerTestIds
  } = useMemo(() => GetStepsContainerTID(testId), [testId]);
  const stepTitle = useMemo(() => getStepName(currentStep, relationship), [currentStep, relationship]);
  const showCheckbox = statement && onStatementChange;
  return /*#__PURE__*/_jsx(Box, {
    className: styles.gradientWrapper,
    testId: StepsContainerTestIds.Root(),
    children: /*#__PURE__*/_jsx(Column, {
      className: styles.inner,
      children: /*#__PURE__*/_jsx(Column, {
        className: styles.content,
        testId: StepsContainerTestIds.Content(),
        children: /*#__PURE__*/_jsx(AnimatePresence, {
          initial: false,
          mode: "wait",
          custom: direction,
          children: /*#__PURE__*/_jsxs(motion.div, {
            custom: direction,
            variants: contentVariants,
            initial: "enter",
            animate: "center",
            exit: "exit",
            transition: contentTransition,
            className: styles.motionWrapper,
            children: [/*#__PURE__*/_jsx(Typography, {
              variant: "h3",
              weight: "normal",
              className: styles.stepTitle,
              testId: StepsContainerTestIds.StepTitle(),
              children: stepTitle
            }), /*#__PURE__*/_jsx("div", {
              className: styles.stepContent,
              children: /*#__PURE__*/_jsx(StepContent, {
                currentStep: currentStep
              })
            }), showCheckbox && /*#__PURE__*/_jsx("div", {
              className: styles.checkboxWrapper,
              children: /*#__PURE__*/_jsx(Checkbox, {
                className: styles.statementCheckbox,
                onChange: e => onStatementChange(e.target.checked),
                testId: StepsContainerTestIds.Footer() + '-checkbox',
                checked: isStatementAccepted,
                children: /*#__PURE__*/_jsx(Typography, {
                  variant: "paragraph1",
                  weight: "light",
                  children: statement
                })
              })
            })]
          }, currentStep)
        })
      })
    })
  });
};